import { SyntheticEvent } from 'react';

import { TNextButtonHook } from '~/src/features/full-buy/containers/GoToNextStepButton/types';

const useStubNextButton = (): TNextButtonHook => ({
    disabled: false,
    onClick: (e: SyntheticEvent) => {
        e.stopPropagation();
        return;
    },
    children: 'need to implement action',
    doNotDisplay: true,
});

export default useStubNextButton;
